/**
*   Interface/model file auto generate for Notification
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/


export enum NOTIFICATION_SCREEN {
	NAVIGATION_MAIN_NAVIGATION = 'NAVIGATION_MAIN_NAVIGATION',
	NAVIGATION_RIDE_DETAIL_SCREEN = 'NAVIGATION_RIDE_DETAIL_SCREEN',
	NAVIGATION_OPEN_EXTERNAL_LINK = 'NAVIGATION_OPEN_EXTERNAL_LINK',
};


export enum NOTIFICATION_TOPICS {
	TOPIC_ALL = '/topics/all',
	TOPIC_ALL_USERS = '/topics/users',
	TOPIC_ALL_DRIVER = '/topics/drivers',
	TOPIC_ALL_CUSTOMER = '/topics/customers',
}

export const NOTIFICATION_SOUND = {
	'NOTIFICATION_CATEGORY_GENERAL': 'notification.MP3',
	'NOTIFICATION_CATEGORY_NEWS': 'notification.MP3',
	'NOTIFICATION_CATEGORY_TRIP': 'notification.MP3',
	'NOTIFICATION_CATEGORY_START_TRIP_MANIFEST': 'start_trip_manifest.MP3',
	'NOTIFICATION_CATEGORY_STOP_TRIP_MANIFEST': 'stop_trip_manifest.MP3',
	'NOTIFICATION_CATEGORY_NEW_PASSENGER': 'new_passenger.MP3',
	'NOTIFICATION_CATEGORY_REMOVE_PASSENGER': 'remove_passenger.MP3',
	'NOTIFICATION_CATEGORY_NEW_SHIPPING': 'new_shipping.MP3',
	'NOTIFICATION_CATEGORY_REMOVE_SHIPPING': 'remove_shipping.MP3',
	'NOTIFICATION_CATEGORY_NEW_DRIVER': 'new_driver.MP3',
	'NOTIFICATION_CATEGORY_REMOVE_DRIVER': 'remove_driver.MP3',
}

export enum NOTIFICATION_CATEGORY {
	NOTIFICATION_CATEGORY_GENERAL = 'NOTIFICATION_CATEGORY_GENERAL',
	NOTIFICATION_CATEGORY_NEWS = 'NOTIFICATION_CATEGORY_NEWS',
	NOTIFICATION_CATEGORY_TRIP = 'NOTIFICATION_CATEGORY_TRIP',
	NOTIFICATION_CATEGORY_START_TRIP_MANIFEST = 'NOTIFICATION_CATEGORY_START_TRIP_MANIFEST',
	NOTIFICATION_CATEGORY_STOP_TRIP_MANIFEST = 'NOTIFICATION_CATEGORY_STOP_TRIP_MANIFEST',
	NOTIFICATION_CATEGORY_NEW_PASSENGER = 'NOTIFICATION_CATEGORY_NEW_PASSENGER',
	NOTIFICATION_CATEGORY_REMOVE_PASSENGER = 'NOTIFICATION_CATEGORY_REMOVE_PASSENGER',
	NOTIFICATION_CATEGORY_NEW_SHIPPING = 'NOTIFICATION_CATEGORY_NEW_SHIPPING',
	NOTIFICATION_CATEGORY_REMOVE_SHIPPING = 'NOTIFICATION_CATEGORY_REMOVE_SHIPPING',
	NOTIFICATION_CATEGORY_NEW_DRIVER = 'NOTIFICATION_CATEGORY_NEW_DRIVER',
	NOTIFICATION_CATEGORY_REMOVE_DRIVER = 'NOTIFICATION_CATEGORY_REMOVE_DRIVER',
}

export interface TypedNotification {
	notification_id?: string;
	notification_title?: string;
	notification_content?: string;
	notification_topic?: string;
	"notification_category"?: string; // 'general' | 'wallet' | 'event' | 'promotion' | 'news' | 'order', // sử dụng general | wallet | event | promotion | news | order
	"notification_image"?: string, // ảnh khi post lên

	notification_user?: string;
	notification_data?: {
		[propKey: string]: string
	};
	notification_schedule?: string | number;
	createdAt?: string;
	createdBy?: string;

	notification_meta?: any;
}